import { RouterProvider } from 'react-router-dom';

// project imports
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import 'dayjs/locale/en-gb';
import { HelmetProvider } from 'react-helmet-async';
import StepProvider from './context/stepContext';
import router from './routes';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {

  return (
    <ThemeCustomization>
      <StepProvider>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
            <ScrollTop>
              <HelmetProvider>
                <RouterProvider router={router} />
              </HelmetProvider>
            </ScrollTop>
          </LocalizationProvider>
        </Provider>
      </StepProvider>
      <ToastContainer autoClose={2000} position="top-center" />
    </ThemeCustomization >
  );
}
